export const environment = {
    production: false,
    apiUrl: "https://white-hat-bots-api-test-h6chd4gufxbehha5.eastus2-01.azurewebsites.net",
    appUrl: "https://app-test.whitehatbots.com",
    adminUrl: "https://dashboard-test.whitehatbots.com",
    googleClientID: "115411781582-f0gb030q2qgdrrjfmufjnps2jk0a8i3h.apps.googleusercontent.com",
};
